// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconMail = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      className: 'ionicon',
      viewBox: '0 0 512 512',
      ...props
    },
    /*#__PURE__*/ React.createElement('rect', {
      x: '48',
      y: '96',
      width: '416',
      height: '320',
      rx: '40',
      ry: '40',
      fill: 'none',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '32'
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'none',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '32',
      d: 'M112 160l144 112 144-112'
    })
  );

export { IconMail };
